<template>
  <div>
    <a-card>
      <a-descriptions>
        <a-descriptions-item label="Event Id">
          {{ basicInfo.id }}
        </a-descriptions-item>
        <a-descriptions-item label="Status">
          {{ basicInfo.statusStr }}
        </a-descriptions-item>
        <a-descriptions-item label="Bureau Name">
          {{ basicInfo.bureauName }}
        </a-descriptions-item>
        <a-descriptions-item label="Completion Date">
          {{ basicInfo.updateTime }}
        </a-descriptions-item>
        <a-descriptions-item label="Product Name">
          {{ basicInfo.productName }}
        </a-descriptions-item>
        <a-descriptions-item label="Submission Date">
          {{ basicInfo.createTime }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
    <crm-report v-if="$route.query.productName.toString() === '7'" />
    <global-lookup v-if="$route.query.productName.toString() === '1'" />
    <global-report-quick-check
      v-if="$route.query.productName.toString() === '2'"
    />
    <crm-report v-if="$route.query.productName.toString() === '8'"></crm-report>
    <!-- 安华理达 查询页 -->
    <anwarida-query
      v-if="$route.query.productName.toString() === '9'"
    ></anwarida-query>
    <!-- 调取客户工商大数 googol-repert-->
    <googol-repert v-if="$route.query.productName.toString() === '3'" />
    <!--详财 detail-report -->
    <detail-report v-if="$route.query.productName.toString() === '4'" />
    <crm-financial-report v-if="$route.query.productName.toString() === '5'" />
    <!-- 财务报表 -->
    <a-card
      v-if="$route.query.productName.toString() === '10'"
      class="financial-report-card"
    >
      <template slot="extra">
        <a-button
          type="primary"
          class="action-button"
          style="margin-right: 8px"
          @click="downloadFinancialReport"
          :loading="downloadLoading"
        >
          下载财报
        </a-button>
        <a-button
          type="primary"
          class="action-button"
          @click="convertFinancialReport"
          :loading="convertLoading"
        >
          转存财报
        </a-button>
      </template>
      <div class="financial-report">
        <div class="report-content">
          <a-row :gutter="16">
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">企业名称：</span>
                <span class="item-value">{{ financialData.companyName }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">年份：</span>
                <span class="item-value">{{ financialData.year }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">资产总额(万元)：</span>
                <span class="item-value">{{ financialData.fixedAssets }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">营业总收入(万元)：</span>
                <span class="item-value">{{ financialData.totalRevenue }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">主营业务收入(万元)：</span>
                <span class="item-value">
                  {{ financialData.mainBusinessRevenue }}
                </span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">纳税总额(万元)：</span>
                <span class="item-value">{{ financialData.totalSales }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">所有者权益(万元)：</span>
                <span class="item-value">
                  {{ financialData.inventoryTotal }}
                </span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">利润总额(万元)：</span>
                <span class="item-value">{{ financialData.totalProfit }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">净利润(万元)：</span>
                <span class="item-value">{{ financialData.netProfit }}</span>
              </div>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" class="report-col">
              <div class="report-item">
                <span class="item-label">负债总额(万元)：</span>
                <span class="item-value">
                  {{ financialData.totalLiabilities }}
                </span>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-card>
  </div>
</template>
<script>
import {
  CrmReport,
  CrmFinancialReport,
  GlobalLookup,
  GoogolRepert,
  DetailReport,
  AnwaridaQuery,
  GlobalReportQuickCheck,
} from './components'
import { mapGetters } from 'vuex'
import request from 'utils/request'
import numeral from 'numeral'

export default {
  data() {
    return {
      basicInfo: {},
      financialData: {
        companyName: '',
        year: '',
        fixedAssets: '',
        totalRevenue: '',
        mainBusinessRevenue: '',
        totalSales: '',
        inventoryTotal: '',
        totalProfit: '',
        netProfit: '',
        totalLiabilities: '',
      },
      downloadLoading: false,
      convertLoading: false,
    }
  },
  async mounted() {
    await this.getBasicInfo()
    if (this.$route.query.productName.toString() === '10') {
      this.getFinancialData()
    }
  },
  methods: {
    getBasicInfo() {
      this.basicInfo = this.bureauReportBasicInfo
      return
    },
    getFinancialData() {
      const id = this.basicInfo.id
      if (!id) {
        this.$message.error('未获取到ID参数')
        return
      }

      request()
        .get(`bureau-report/query/zcx/detail/${id}`)
        .then(response => {
          if (response.data && response.code === '0000') {
            const data = response.data || {}
            this.financialData = {
              companyName: data.companyName,
              year: data.years,
              fixedAssets: this.formatNumber(data.a1),
              totalRevenue: this.formatNumber(data.a2),
              mainBusinessRevenue: this.formatNumber(data.a3),
              totalSales: this.formatNumber(data.a4),
              inventoryTotal: this.formatNumber(data.a5),
              totalProfit: this.formatNumber(data.a6),
              netProfit: this.formatNumber(data.a7),
              totalLiabilities: this.formatNumber(data.a8),
            }
          } else {
            this.$message.error(response.data.message || '获取财务数据失败')
          }
        })
        .catch(error => {
          console.error('获取财务数据出错:', error)
          this.$message.error('获取财务数据出错')
        })
    },
    formatNumber(value) {
      if (!value && value !== 0) return '0.00'
      return numeral(value).format('0,0.00')
    },
    downloadFinancialReport() {
      const id = this.basicInfo.id
      if (!id) {
        this.$message.error('未获取到ID参数')
        return
      }

      // 设置按钮loading状态
      this.downloadLoading = true
      this.$message.loading('正在下载财报...')

      request()
        .get(`bureau-report/export/zcx/detail/${id}`, {
          responseType: 'blob', // 重要：设置响应类型为blob
        })
        .then(() => {
          this.$message.success('财报下载成功')
        })
        .catch(error => {
          console.error('下载财报出错:', error)
          this.$message.error('下载财报失败')
        })
        .finally(() => {
          // 无论成功还是失败，都需要重置loading状态
          this.downloadLoading = false
        })
    },
    convertFinancialReport() {
      const id = this.basicInfo.id
      if (!id) {
        this.$message.error('未获取到ID参数')
        return
      }

      // 设置按钮loading状态
      this.convertLoading = true
      this.$message.loading('正在转存财报...')

      request()
        .get(`bureau-report/zcx/convert/finance/detail/${id}`)
        .then(response => {
          if (response.code === '0000') {
            this.$message.success('财报转存成功')
          } else {
            this.$message.error(response.message || '财报转存失败')
          }
        })
        .catch(error => {
          console.error('转存财报出错:', error)
          this.$message.error('财报转存失败')
        })
        .finally(() => {
          // 无论成功还是失败，都需要重置loading状态
          this.convertLoading = false
        })
    },
  },
  computed: {
    ...mapGetters('app', ['bureauReportBasicInfo']),
  },
  components: {
    CrmFinancialReport,
    CrmReport,
    GlobalLookup,
    GlobalReportQuickCheck,
    AnwaridaQuery,
    GoogolRepert,
    DetailReport,
  },
}
</script>

<style>
.financial-report-card {
  margin-top: 16px;
}

.action-button {
  font-size: 12px;
}

.report-content {
  padding: 8px;
}

.report-col {
  margin-bottom: 16px;
}

.report-item {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 12px;
  height: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.report-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}

.item-label {
  display: block;
  color: #8c8c8c;
  font-size: 12px;
  margin-bottom: 4px;
}

.item-value {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #262626;
}
</style>
